import React from 'react'
import SCR from '../components/SCR.js';
//import RezCentral from '../components/RezCentral.js';
import {Container, Row, Col, Button} from 'react-bootstrap/';

export default class Confirmation extends React.Component {
  constructor(props){
      super(props);

      this.state = {
        //addRez : {},
        getRez : {}
      }
  }

  componentDidUpdate(){
     SCR.resizeParent();
  }

  componentDidMount() {
    //SCR.resizeParent();
    
    //window.history.replaceState(null, "Savannah Car Rentals Reservation Confirmation", "/thankyou");
    //setTimeout(SCR.fireTracking, 1500);

    /*if (typeof window !== "undefined") {
      if (window.fbq != null)
        window.fbq('track', 'PageView');

      if(window.gtag != null)
        window.gtag('config', 'UA-12341353-18');
    }*/
  }

  getDateString(d, dl){
    return ('0' + (d.getMonth()+1)).slice(-2) + dl +  ('0' + d.getDate()).slice(-2) + dl +  d.getFullYear();
  }

  render(){
    //console.log('Confirmation render called');
    var rez = this.props.confirmationDetails;

    var Total = '0.00';
    var Extras = [];

    if(typeof rez.totalPricing !== "undefined")
      Total = rez.totalPricing.totalCharges;

    if(typeof rez.dailyExtras !== 'undefined' && rez.dailyExtras.length > 0){
      var extras = rez.dailyExtras;
        Extras = extras.map(
          (extra, index) => {
            if(extra.autoApplied === 'FALSE'){
              //console.log(extra.extraCode)
              return (
                <div key={extra.extraCode + '-' + index}>{extra.extraDesc}</div>);
            }else {
              return [];
            }
          });
    }

    return (
      <Container id="confirmation" fluid>
        <Row className="print-container"><Col><Button onClick={() => window.print()}>Print</Button></Col></Row>
        <Row>
          <Col><p>{rez.confirmMessage}</p>
          <p><b>Confirmation Number:</b> #{rez.confirmNum}</p></Col>
        </Row>

        <Row>
          <Col><b>Customer Info</b> <br/>
          {rez.renterFirst} {rez.renterLast} <br/>
          {rez.renterCellPhone}<br/>
          {rez.emailAddress}</Col>
        </Row>

        <Row>
          <Col><b>Pick up</b><br/>
          {SCR.getCity(rez.rentalLocationID)} <br/>
          {SCR.fixDateString(rez.pickupDateTime)}</Col>
        </Row>
        <Row>
          <Col><b>Drop off</b><br/>
          {SCR.getCity(rez.returnLocationID)} <br/>
          {SCR.fixDateString(rez.returnDateTime)}</Col>
        </Row>
        <Row>
          <b>Extras</b><br/>
          {Extras}
        </Row>
        <Row className="vehicle-container">
          <Col><b>Vehicle</b><br/>
          <img src={'reservation/' + rez.classImgURL.toLowerCase()} alt="" /><br/>
          <b>{rez.modelDesc}</b><br/>
          {rez.confirmedRate}</Col>
        </Row>

        <Row><Col><b>Total</b> $ {Total}</Col></Row>
      </Container>
    );
  }
}
